import { useQuery } from "@tanstack/react-query";
import {
  type OfficeAvailability,
  officeAvailabilityKeys,
  officeAvailabilityService,
} from "@/api/profiles";

/**
 * Fetch per-website-edition office availability for a firm (cross-firm — the
 * caller passes the target profile's `companyId`). Used to append the
 * `(No offices)` suffix + disabled state to Website options that have no
 * qualifying office for that edition.
 *
 * When `companyId` is null (e.g. create mode before a firm is picked) the query
 * is disabled and `data` is `undefined`, so consumers treat every edition as
 * available until availability is known.
 */
export function useOfficeAvailability(companyId: string | null) {
  return useQuery<OfficeAvailability>({
    queryKey: companyId
      ? officeAvailabilityKeys.byCompany(companyId)
      : [...officeAvailabilityKeys.all, "__noop__"],
    queryFn: () => officeAvailabilityService.getByCompanyId(companyId as string),
    enabled: Boolean(companyId),
    staleTime: 60_000,
  });
}
